// @flow
import * as React from "react";
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import CreatableSelect from "react-select";
import {
  BasicUserInfo,
  EvidencePeriodData,
  InvitesResponse,
  MasterDataInFilter,
  MasterDataTeachers,
  ReactSelectOption,
  TeacherClass,
  TeacherInfo,
} from "../../../../../../../store/onboarding/types";
import { ValueType } from "react-select/src/types";
import { ApplicationState } from "../../../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import {
  changeTeachersFilter,
  clearClassesAssignedToTeacher,
  getClassFromStudentRowsTeachers,
  getClassesAssignedToTeacher,
  getClassesAssignedToTeacherSuccess,
  getTeachers,
  openTeacherInviteIndividuallyModal,
} from "../../../../../../../store/onboarding/actions";
import { connect, useSelector } from "react-redux";
import { getFullName, uniqueByKey } from "../../../../../../../utils/NamesUtils";
import { getBasicUserInfoFromString } from "../../../../../../../utils/StudentMapUtils";
import { USState } from "../../../../../States";
import { Grade } from "../../../../../../../store/groups/types";
import useUserRole from "../../../../../../../utils/hooks/useUserRole";
import Select from "react-select";

type PropsFromState = {
  teacherRoster: Array<TeacherInfo>;
  teacherIdFilter?: number[];
  dataGradesFilter: Grade[];
  invites: InvitesResponse;
  errors: {
    getMasterDataInFilter?: string;
  };
  isLoading: {
    getMasterDataInFilter?: boolean;
  };
};

type DispatchProps = {
  getTeachers: () => any;
  clearClassesAssignedToTeacher: () => any;
  changeTeachersFilter: (teacherIdFilter?: number[]) => any;
  //getClassesAssignedToTeacher: (teacherId: number) => any;
  getClassFromStudentRowsTeachers: (teacherFilter: number[]) => any;
  openTeacherInviteIndividuallyModal: (newTeacher?: BasicUserInfo) => any;
  getClassesAssignedToTeacherSuccess: (teachersClasses: Array<TeacherClass>) => any;
};

type Props = PropsFromState & DispatchProps;

const TeachersFilter: FunctionComponent<Props> = ({
  isLoading,
  getTeachers,
  teacherRoster,
  invites,
  teacherIdFilter,
  dataGradesFilter,
  changeTeachersFilter,
  //getClassesAssignedToTeacher,
  getClassesAssignedToTeacherSuccess,
  getClassFromStudentRowsTeachers,
  openTeacherInviteIndividuallyModal,
  clearClassesAssignedToTeacher,
}) => {
  const [isNewInvite, setIsNewInvite] = useState(false);
  
  const { isDistrictOwner } = useUserRole();
  const teachersDataInFilter = useSelector<
    ApplicationState,
    MasterDataTeachers[]
  >((s) => s.onboarding.masterDataInFilter.teachers);

  // useEffect(() => {
  //   getTeachers();
  // }, []);

  useEffect(() => {
    if (isNewInvite) {
      const { successful_invites } = invites;
      if (successful_invites.length) {
        const { user } = successful_invites[0];
        changeTeachersFilter([user.id]);
      }
      setIsNewInvite(false);
    }
  }, [teachersDataInFilter]);

  const handleSelectedTeacherChange = (
    option: ValueType<ReactSelectOption<MasterDataTeachers>, any>
  ) => {
    if (option) {
      const teacherIds: number[] = (option as ReactSelectOption<MasterDataTeachers>[])?.map((teacher) => teacher.value.teacher_id) ?? [];
      changeTeachersFilter(teacherIds);
      //getClassesAssignedToTeacher(teacherIds);
      getClassesAssignedToTeacherSuccess(getClassFromStudentRowsTeachers(teacherIds));
    } else {
      changeTeachersFilter();
      clearClassesAssignedToTeacher();
    }
  };

  const teachersByCurrentDataPeriod: MasterDataTeachers[] = useMemo(() => 
    teachersDataInFilter.filter((teacher) => teacher.teacher_id !== null)
  ,[teachersDataInFilter])

  const options: Array<ReactSelectOption<MasterDataTeachers>> = useMemo(() => {
    return (uniqueByKey(teachersByCurrentDataPeriod, 'teacher_id') || []).map((teacherInfo: MasterDataTeachers) => ({
      label: getFullName(teacherInfo),
      value: teacherInfo,
    }));
  }, [teachersByCurrentDataPeriod]);

  const handleInviteTeacher = (input: string) => {
    if(isDistrictOwner) {
      setIsNewInvite(true);
      openTeacherInviteIndividuallyModal(getBasicUserInfoFromString(input));
    }
  };

  
  return (
    <>
      <h4 className="font-weight-bold m-0">Educator(s)</h4>
      {
        isDistrictOwner 
        ?
          <CreatableSelect
            isMulti
            isClearable
            placeholder="All"
            name="teachersFilter"
            styles={{ menu: (styles) => ({ ...styles, zIndex: 100 }) }}
            isLoading={isLoading.getMasterDataInFilter}
            options={options}
            value={options.filter((o) => teacherIdFilter?.some((teacherId) =>  o.value.teacher_id === teacherId))}
            onChange={handleSelectedTeacherChange}
            onCreateOption={handleInviteTeacher}
            formatCreateLabel={(input: string) => `Invite '${input}'`}
          />
        : 
          <Select
            isMulti
            isClearable
            placeholder="All"
            name="teachersFilter"
            styles={{ menu: (styles) => ({ ...styles, zIndex: 100 }) }}
            isLoading={isLoading.getMasterDataInFilter}
            options={options}
            value={options.filter((o) => teacherIdFilter?.some((teacherId) =>  o.value.teacher_id === teacherId))}
            onChange={handleSelectedTeacherChange}
          />
      }
    </>
  );
};

const mapStateToProps = ({ onboarding, dataFilter }: ApplicationState): PropsFromState => {
  return {
    teacherRoster: onboarding.teachersRoster,
    teacherIdFilter: onboarding.teacherIdFilter,
    dataGradesFilter: dataFilter.dataGradesFilter,
    invites: onboarding.invites,
    errors: {
      getMasterDataInFilter: onboarding.errors.getMasterDataInFilter,
    },
    isLoading: {
      getMasterDataInFilter: onboarding.isLoading.getMasterDataInFilter,
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      getTeachers: getTeachers,
      changeTeachersFilter: changeTeachersFilter,
      openTeacherInviteIndividuallyModal: openTeacherInviteIndividuallyModal,
      //getClassesAssignedToTeacher: getClassesAssignedToTeacher,
      getClassesAssignedToTeacherSuccess: getClassesAssignedToTeacherSuccess,
      getClassFromStudentRowsTeachers: getClassFromStudentRowsTeachers,
      clearClassesAssignedToTeacher: clearClassesAssignedToTeacher,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TeachersFilter);
